import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";

export default function Shippingcharges() {
  const [us_ground, setUsground] = useState("");
  const [us_rushit, setUsrushit] = useState();
  const [canada, setcanada] = useState("");
  const [international, setinternational] = useState("");
  const [ground, setground] = useState();
  const [id, setid] = useState();
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    getshippingcharge();
  }, []);

  const getshippingcharge = () => {
    setLoading(true);

    PostService(API_URL.GET_SHIPPING_CHARGE, {}).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setLoading(false);
        setUsground(res?.data?.data?.us_ground);
        setcanada(res?.data?.data?.canada);
        setUsrushit(res?.data?.data?.us_rushit);
        setinternational(res?.data?.data?.international);
        setid(res?.data?.data?.id);
        setground(res?.data?.data?.ground);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  function submit() {
    if (!international || !us_ground || !us_rushit || !canada || !ground) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    const data = { us_ground, us_rushit, international, ground, canada, id };
    PostService(API_URL.UPDATE_SHIPPING_CHARGE, data).then((res) => {
      setsubmitLoader(false);
      if (res?.data?.status) {
        showSuccessAlert(res?.data?.message, getshippingcharge);
      } else {
        showErrorAlert(res.data?.message);
      }
    });
  }
  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Shipping Charge</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Shipping Charge</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        {!loading && (
          <div class="card-body mt-3">
            {/* <h4 class="card-title">Add Company Details</h4> */}
            <div className="row offset-md-1">
              <div className="col-md-5 col-12 form-group">
                <label>US Ground $</label>
                <input
                  type="number"
                  min={0}
                  placeholder="Enter US Ground"
                  className="form-control"
                  value={us_ground}
                  onChange={(e) => setUsground(e?.target?.value)}
                />
                {error && !us_ground && (
                  <div className="error mt-1">US Ground is required</div>
                )}
              </div>
              <div className="col-md-5 col-12 form-group">
                <label>US Rush-It $</label>
                <input
                  type="number"
                  min={0}
                  placeholder="Enter US Rush-It"
                  className="form-control"
                  value={us_rushit}
                  onChange={(e) => setUsrushit(e?.target?.value)}
                />
                {error && !us_rushit && (
                  <div className="error mt-1">US Rush-It is required</div>
                )}
              </div>
            </div>
            <div className="row offset-md-1">
              <div className="col-md-5 col-12 form-group">
                <label>Canada $</label>
                <input
                  type="number"
                  min={0}
                  placeholder="Enter Canada "
                  className="form-control"
                  value={canada}
                  onChange={(e) => setcanada(e?.target?.value)}
                />
                {error && !canada && (
                  <div className="error mt-1">Canada is required</div>
                )}
              </div>
              <div className="col-md-5 col-12 form-group">
                <label>International $</label>
                <input
                  type="number"
                  min={0}
                  placeholder="Enter International "
                  className="form-control"
                  value={international}
                  onChange={(e) => setinternational(e?.target?.value)}
                />
                {error && !international && (
                  <div className="error mt-1">International is required</div>
                )}
              </div>
            </div>
            <div className="row offset-md-1">
              <div className="col-md-5 col-12 form-group">
                <label>Ground 6"x8" $</label>
                <input
                  type="number"
                  min={0}
                  placeholder="Enter Ground 6x8"
                  className="form-control"
                  value={ground}
                  onChange={(e) => setground(e?.target?.value)}
                />
                {error && !ground && (
                  <div className="error mt-1">Ground 6"x8" is required</div>
                )}
              </div>
            </div>
            <div>
              <div className="offset-md-1">
                <button
                  className="btn btn-primary ml-3"
                  onClick={() => {
                    submit();
                  }}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        {loading ? (
          <div className="LoaderSpinner">
            <MoonLoader
              color={"#003bff"}
              loading={loading}
              speedMultiplier={0.6}
              size={50}
            />
            <div>Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
